import React from 'react';
import {
  TextareaField,
  CheckboxField,
} from '../../../../../components/FormikFields';

export const terminateAgreementFormConfig = ({ t }) => [
  {
    fields: [
      {
        name: 'reason',
        label: t('special_billing.reason_label'),
        labelClassName: 'reasonLabel',
        component: TextareaField,
        componentProps: {
          className: 'reasonField',
          placeholder: t('special_billing.reason_placeholder'),
        },
        required: false,
      },
      {
        name: 'terms',
        component: CheckboxField,
        componentProps: {
          label: (
            <label>
              {t('i-accept-to-the')}{' '}
              <a
                href="https://nbr.gov.bh"
                className="text-decoration-underline text-dark fw-bold"
              >
                {t('special_billing.terms-and-conditions')}
              </a>
            </label>
          ),
        },
        required: true,
      },
    ],
  },
];
